import React, { Component } from 'react';
import { withServerSideProps } from '@lib/withServerSideProps';
import { shopDetailsPageQuery } from '@queries/pages/shopDetails';
import { mapShopDetailsPageData } from '@lib/page-data/shopDetails.map';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { pushPageViewEvent } from '@lib/atm';

class ShopDetails extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData,
    } = this.props;
    const {
      shopData,
      pageTitle,
    } = pageData;

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: ['brands', shopData.slug],
        retailer: [shopData],
        isProductView: true,
        title: pageTitle
      }
    );
  }

  render() {
    const {
      pageData,
      locale,
      requestData,
      userSessionData,
      globalPageData,
    } = this.props;

    const {
      pageTitle,
      shopData,
      parentCategories,
      subCategories,
      shopConfig,
    } = pageData;

    return (
      <Page
        pageTitle={pageTitle}
        metaDescription={shopData.metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.ShopPage
          {...shopData}
          parentCategories={parentCategories}
          subCategories={subCategories}
          shopConfig={shopConfig}
          locale={locale}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: shopDetailsPageQuery,
  getPageQueryVariables: ({ query }) => ({
    shopSlug: query.shopSlug,
    locale: query.locale,
  }),
  pageDataMapper: mapShopDetailsPageData,
});

export default ShopDetails;
